var setupDocument = function() {
  // fix for mousewheel events
  document.addEventListener("mousewheel", function(event) {
    if ((document.activeElement || {}).type === "number") {
      document.activeElement.blur();
    }
  });

  if (window.RAILS_ENV == 'test') {
    var cb = function(e) {
      var t = e.target;
      var screen = " Screen " + document.body.clientWidth + " x " + document.body.clientHeight;
      console.log('^^^^^^^ DEBUG CLICK ON ' + t.nodeName + '#' + t.id + ' ' + t.className + screen + ' TEXT: ' + t.innerText);
    };
    document.addEventListener('click', cb);
  } 
}

export default setupDocument;